<template lang="pug">
  #promo(:class="{'promo--home': isHome, 'promo--hide': isHide}")

</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Promo',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['author']),
    isHome() {
      return this.$route.path === '/'
    },
    isHide() {
      return this.author && this.author.nickname
    },
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>

#promo {

  position: fixed;
  bottom: 0;
  right: vw(13);
  width: vw(152);
  height: vw(170);
  background: url('~@/assets/images/common/promo-richart.png') no-repeat 0 0 / vw(152) vw(348);
  animation: promoRichart 1.5s steps(2) infinite;
  z-index: 2;

  @keyframes promoRichart {
    to {background-position: 0 vw(-348);}
  }

  @include desktop {
    display: none;
  }

  &.promo--home {
    bottom: calc(vw(54) + env(safe-area-inset-bottom));
  }

  &.promo--hide {
    display: none;
  }

}

</style>
